import { createHttpRequest } from "../../../../../api/utils/httpRequest"
import type { HttpHeaders } from "../../../../../api/types"
import type { GoogleReviewReplyInput, GoogleReviewReplySuggestionsResponse, ListReviewsResponse } from "./types"

export const fetchGoogleReviews = async (headers: HttpHeaders, locationId: string): Promise<ListReviewsResponse> => {
    const params = new URLSearchParams({ locationId: locationId })
    const response = await createHttpRequest({
        method: "GET",
        path: `/google-business/reviews?${params.toString()}`,
        headers: headers,
    })

    return (response?.data ?? response) as ListReviewsResponse
}

export const fetchGoogleReviewReplySuggestions = async (
    headers: HttpHeaders,
    reviews: GoogleReviewReplyInput[]
): Promise<GoogleReviewReplySuggestionsResponse> => {
    const response = await createHttpRequest({
        method: "POST",
        path: "/google-business/reviews/reply-suggestions",
        headers: {
            ...headers,
            "Content-Type": "application/json",
        },
        body: {
            reviews: reviews,
        },
    })

    return (response?.data ?? response) as GoogleReviewReplySuggestionsResponse
}
